import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PlayArrow from "@material-ui/icons/PlayArrow";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import HelloSuperStarLogo from "../../Assets/Images/HelloSuperStarLogo.png";
import { LocationContext } from "../../CustomHelper/Helper";
import "./css/SignUp.css";
import DropDownLanguage from "./DropDownLanguage";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
// import "../../App.css";
import {useI18n} from "../../i18n";

const Signup = () => {
  const { t } = useI18n();

  const { myLocation, regPromo, setRegPromo } = useContext(LocationContext);

  const loading = false;
  const [changeIcon, setChange] = useState(false);
  const [changIcon1, setChangeIcon1] = useState(false);
  const [confirmPassAlert, setConfirmPassAlert] = useState(false);
  const [customStyle, setCustomStyle] = useState(false);
  const [infoBuffer, setInfoBuffer] = useState(false);
  const [phoneError, setPhoneError] = useState("")

  function handleChangeIcon() {
    setChange(!changeIcon);
  }

  function handleChangeIcon1() {
    setChangeIcon1(!changIcon1);
  }

  const history = useHistory();
  const [registerInput, setRegister] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
    error_list: [],
  });

  const [getPhone, setPhone] = useState("");

  const handleInput = (e) => {
    setCustomStyle(true);
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const registerSubmit = (e) => {
    e.preventDefault();
    setInfoBuffer(true);
    const data = {
      first_name: registerInput.first_name,
      // last_name: registerInput.last_name,
      email: registerInput.email,
      deviceId: 'Web',
      phone: getPhone,
      password: registerInput.password,
      countryCode: myLocation?.countryCode
        ? myLocation.countryCode
        : "unknown",
    };


    if (data?.phone.length < 7) {
      setInfoBuffer(false);
      setPhoneError('phone number not valid !')
      return
    }
    // console.log(data)
    // return

    if (registerInput.password !== registerInput.confirm_password) {
      setConfirmPassAlert(true);
      setInfoBuffer(false);

      setRegister((prev) => {
        return { ...prev, confirm_password: "" };
      });
    } else {
      setConfirmPassAlert(false);
      axios.get("/sanctum/csrf-cookie").then((response) => {
        axios.post(`/api/register`, data).then((res) => {
          setInfoBuffer(false);

          if (res.data.status === 200) {
            // localStorage.setItem("auth_token", res.data.token);
            // localStorage.setItem("auth_id", res.data.id);
            // localStorage.setItem("isLoggedIn", rememberMe);
            localStorage.setItem("auth_token", res.data.token);
            localStorage.setItem("auth_name", res.data?.user?.first_name);
            localStorage.setItem("auth_email", res.data?.user?.email);
            localStorage.setItem("auth_phone", res.data?.user?.phone);
            localStorage.setItem("auth_id", res.data.id);
            localStorage.setItem("auth_image", res.data?.user?.image);

            //for reg mode 
            if (regPromo?.eventmode) {
              setRegPromo({ ...regPromo, isReg: true, phone: res.data?.user?.phone })
              history.push("/");
              return
            }

            //swal("Success", res.data.message, "success");
            // history.push("/otp");
            history.push("/profile/info");
          } else {
            setInfoBuffer(false);
            setRegister({
              ...registerInput,
              error_list: res.data.validation_errors,
            });
          }
        });
      });
    }
  };


  const handleSocialSignUp = (provider) => {
    console.log(provider)
    axios.post('/api/social_login_uri', {provider: provider}).then((response) => {
      if(response.status === 200){
        window.open(response.data.redirect_uri,'_blank')
      }
    });
  }

  const getSocialInfo = () => {
    const guiCode = new URLSearchParams(window.location.search).get('code')
    if(guiCode){
      axios.get('/api/social_user_info', {
        params: {
          code: guiCode,
          provider: 'google'
        }
      }).then((response) => {
        if(response.status === 200){
  
          let name = response.data.user.user.name.split(' ')
          setRegister({
            first_name: name[0] +' '+ name[1],
            last_name: name[1],
            email: response.data.user.email,
            password: '',
            dob: '',
            error_list: []
          })
        }
      })
    }
  }

  useEffect(() => {
    getSocialInfo()
  },[])

  return (
    <>
      <div className="bg-img mobileLog">
        <div className="container-fluid">
          <div className="row d-flex align-items-center">
            <div
              className="col-md-12  mx-auto row d-flex justify-content-between align-items-center"
              style={{ minHeight: "100vh" }}
            >
              <div className="col-md-6 align-items-center ">
                <center>
                  {" "}
                  <div>
                    <img
                      src={HelloSuperStarLogo}
                      alt="Hello Super Star Logo "
                      className="MobileLogoLog"
                    />
                  </div>
                  <div>
                    <Link to="/tutorial">
                      <button className="btn mt-3 TabBtnLog px-4 Virtual">
                        <PlayArrow />
                        <span className="mx-2 ">{t('Virtual_Tour_text')}</span>
                      </button>
                    </Link>
                  </div>
                </center>
              </div>

              <div className="col-md-6 align-items-center mobile-sign-view">
                <div className="d-flex align-items-center justify-content-center ">
                  <div className="col-md-7 wrapperLog SignBgColor" style={{maxWidth:"400px !important"}}>
                    <form onSubmit={registerSubmit} className="row w-100">
                      <center>
                        <h4 className="fw-bold mt-2 mb-3 log-title">
                          Hello Super Stars
                        </h4>
                      </center>

                      {/* <div className="social-login-container">
                        <a className="social-login-btn social-login-btn-google" href="#" onClick={(e) => {
                          e.preventDefault();
                          handleSocialSignUp('google')
                        }}>
                          <i class="fa fa-google"></i>
                          Signup With Google
                        </a><br/>
                        <a className="social-login-btn social-login-btn-facebook" href="#" onClick={(e) => {
                          e.preventDefault()
                          handleSocialSignUp('facebook')
                        }}>
                           <i class="fa fa-facebook"></i>
                          Signup With Facebook</a>
                      </div> */}
                      <div className="text-center mb-2 d-flex justify-content-center">
                        <button 
                          type="button"
                          className="btn d-flex align-items-center justify-content-center gap-2 text-white fw-semibold rounded shadow-sm w-50"
                          style={{
                            backgroundColor: '#4285f4',
                            border: 'none',
                            fontFamily: 'Roboto, Arial, sans-serif',
                            fontSize: '0.75rem',
                            padding: '0.5rem 1rem',
                            transition: 'all 0.2s ease-in-out',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                          }}
                          onClick={(e) => handleSocialSignUp('google')}
                          onMouseEnter={(e) => {
                            e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                            e.target.style.transform = 'translateY(-1px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                            e.target.style.transform = 'translateY(0)';
                          }}
                        >
                          <i className="fab fa-google" style={{ color: '#ffffff', fontSize: '1rem' }}></i>
                          <span>Sign up with Google</span>
                        </button>
                      </div>

                      <div class="form-group w-100 mb-3 ">
                        <label
                          className="text-lead new_log"
                          for="exampleInputEmail1"
                        >
                          {t('Full_Name_text')}
                        </label>
                        <input
                          type="text"
                          name="first_name"
                          onChange={handleInput}
                          value={registerInput.first_name}
                          className=" log_in_new py-2 px-2"
                          placeholder={t('Enter_Full_Name_text')}
                          required
                        />
                        <small
                          id="emailHelp"
                          class="form-text text-danger pt-2"
                        >
                          {registerInput.error_list.first_name}
                        </small>
                      </div>

                      <div class="form-group col-md-6 mb-3 ">
                        <label
                          className="text-lead new_log"
                          for="exampleInputEmail1"
                        >
                          {t('Email_text')}
                        </label>
                        <input
                          type="email"
                          name="email"
                          onChange={handleInput}
                          value={registerInput.email}
                          className=" log_in_new py-2 px-2"
                          placeholder= {t('Enter_Email_text')}
                        />

                        <small
                          id="emailHelp"
                          class="form-text text-danger pt-2"
                        >
                          {registerInput.error_list.email}
                        </small>
                      </div>

                      <div class="form-group col-md-6 mb-3">
                        <label
                          className="text-lead new_log"
                          for="exampleInputEmail1"
                        >
                          {t('Phone_text')}
                        </label>
                        <PhoneInput
                          className="log_in_new "
                          country={
                            myLocation?.countryCode
                              ? myLocation.countryCode.toLowerCase()
                              : "bd"
                          }
                          name="phone"
                          onChange={(phone) => setPhone(phone)}
                          placeholder= {t('Phone_Number_text')}
                        />

                        <small
                          id="emailHelp"
                          class="form-text text-danger pt-2"
                        >
                          {registerInput.error_list.phone}
                          {phoneError}
                        </small>
                      </div>

                      <div class="form-group col-md-6 mb-3">
                        <label
                          className="text-lead new_log"
                          for="exampleInputEmail1"
                        >
                          {t('Password_text')}
                        </label>
                        <span className="in-eye-pas">
                          <input
                            type={changeIcon ? `text` : `password`}
                            name="password"
                            onChange={handleInput}
                            value={registerInput.password}
                            onClick={() => {
                              setCustomStyle(true);
                            }}
                            className="log_in_new py-2 px-2"
                            placeholder= {t('Password_text')}
                          required
                          />
                          <span
                            onClick={handleChangeIcon}
                            className="eye-icons"
                          >
                            <FontAwesomeIcon
                              icon={changeIcon ? faEye : faEyeSlash}
                            />
                          </span>
                        </span>
                      </div>

                      <div class="form-group col-md-6 mb-3">
                        <label
                          className="text-lead new_log"
                          for="exampleInputEmail1"
                        >
                          {t('Confirm_Password_text')}
                        </label>
                        <span className="in-eye-pas">
                          <input
                           type={changIcon1 ? `text` : `password`}
                           onChange={handleInput}
                           name="confirm_password"
                           value={registerInput.confirm_password}
                           required
                           onClick={() => {
                             setCustomStyle(true);
                           }}
                            className="log_in_new py-2 px-2"
                            placeholder={t('Password_text')}
                          />
                          <span
                           onClick={handleChangeIcon1}
                            className="eye-icons"
                          >
                            <FontAwesomeIcon
                              icon={changIcon1 ? faEye : faEyeSlash}
                            />
                          </span>

                        </span>
                        <small
                          id="emailHelp"
                          class="form-text text-danger pt-2"
                        >
                           {confirmPassAlert && <> Password Mismatched!</>}
                          
                        </small>
                      </div>


                      <div className="text-center my-4">
                        <Button
                          to="/otp"
                          disabled={loading}
                          className="btn BtnLogin w-50"
                          type="submit"
                        >
                          {infoBuffer ? (
                            <>
                              {" "}
                              <i className="fas fa-spinner fa-pulse"></i>
                              &nbsp;
                            </>
                          ) : (
                            <></>
                          )}
                          {t('Signup_text')}
                        </Button>
                        
                      </div>
                      <div className="text-center mb-4">
                        <Link
                          to="/login"
                          className="btn btn-outline-warning BtnLoginSub px-3 mx-2 userBtn-font w-50"
                        >
                            {t('Log_In_text')}
                        </Link>
                      </div>
                    </form>

                    {/* <div className="d-flex  justify-content-around mb-3 ">
                      <Link
                        to="/login"
                        className="btn btn-outline-warning BtnLoginSub px-3 mx-2 userBtn-font"
                      >
                          {t('Log_In_text')}
                      </Link>
                      <Link
                        // to="/guestUser"
                        to="/guest_mode"
                        className="btn btn-outline-warning BtnLoginSub px-3 mx-2 userBtn-font"
                      >
                        {t('Guest_user_text')}
                      </Link>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="topright text-light">
          <DropDownLanguage />
        </div>
      </div>0
    </>
  );
};

export default Signup;
